import { render, staticRenderFns } from "./ui-pager-component.vue?vue&type=template&id=17e9ffa3&scoped=true&"
import script from "./ui-pager-component.vue?vue&type=script&lang=ts&"
export * from "./ui-pager-component.vue?vue&type=script&lang=ts&"
import style0 from "./ui-pager-component.vue?vue&type=style&index=0&id=17e9ffa3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e9ffa3",
  null
  
)

export default component.exports